// ---------- Utilities ----------

// Safe localStorage wrapper
const safeStorage = {
    get(key) {
        try { return localStorage.getItem(key); }
        catch { return null; }
    },
    set(key, value) {
        try { localStorage.setItem(key, value); }
        catch { /* ignore */ }
    }
};

// Create live region announcer for screenreaders
function createAnnouncer(id) {
    const announcer = document.createElement('div');
    Object.assign(announcer, {
        id,
        style: 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden'
    });
    announcer.setAttribute('aria-live', 'polite');
    announcer.setAttribute('aria-atomic', 'true');
    document.body.appendChild(announcer);
    return announcer;
}

// Detect system theme preference
function getSystemTheme() {
    if (window.matchMedia?.('(prefers-color-scheme: dark)').matches) {
        return 'dark';
    }
    return 'light';
}

// Detect system font-scale preference (approximation via devicePixelRatio)
function getSystemFontScale() {
    const ratio = window.devicePixelRatio || 1;
    if (ratio >= 2) return 200;
    if (ratio >= 1.5) return 150;
    return 100;
}

// Usability toggle functionality
document.addEventListener('DOMContentLoaded', function() {
    const usabilityToggle = document.querySelector('.usability-toggle');
    const usabilitySubmenu = document.querySelector('.usability-submenu');

    if (usabilityToggle && usabilitySubmenu) {
        usabilityToggle.addEventListener('click', function() {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';

            // Toggle state
            this.setAttribute('aria-expanded', !isExpanded);
            usabilitySubmenu.hidden = isExpanded;
        });

        // Close submenu when clicking outside
        document.addEventListener('click', function(event) {
            if (!event.target.closest('.usability-wrapper')) {
                usabilityToggle.setAttribute('aria-expanded', 'false');
                usabilitySubmenu.hidden = true;
            }
        });

        // Close on escape key
        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && usabilityToggle.getAttribute('aria-expanded') === 'true') {
                usabilityToggle.setAttribute('aria-expanded', 'false');
                usabilitySubmenu.hidden = true;
                usabilityToggle.focus();
            }
        });
    }
});